module.exports = __webpack_public_path__ + "img/icon4@3x.7ef780be.png";